<template>
<main>
	<div class="container">
		<aside id="profile" class="profile">
			<img src="./../../public/img/brandon-barringer.jpg" alt="Brandon Barringer" class="profile__img">
			<div class="content">
				<h1 class="content__headline headline">Brandon Barringer</h1>
				<p class="content__subheadline subheadline">Creative Designer &amp; Developer with a knack for problem solving, creativity and process efficiancy</p>
				<div class="content__description">
					<p>Hi. I'm Brandon. I've been a designer and developer since my first introduction to graphic communications in 2004.</p>
					<p>I'm a huge nerd that is constantly looking for the best solution to any problem in life and at work, like the most efficient route to take home, the perfect way to stack a sandwhich and the actual solution to <code>8&#247;2(2+2)</code> <small><em> It's 16 by the way</em></small></p>
					<p>Anyway, if you're interested in having a chat just..</p>
				</div>
				<a href="mailto:barringerbrandon@gmail.com" class="button">Contact Me</a>
				<p><small>Oh! And don't forget to checkout my <a href="https://github.com/brandonbarringer">GitHub</a>. If you want to see some of my more "fun" code, check out my <a href="https://gist.github.com/brandonbarringer">Gists</a> too.</small></p>
			</div>
		</aside>
		<section id="history" class="history">
			<div class="history__header">
				<h1 class="history__headline headline">History of Learning, Solving &amp; Creating</h1>
			</div>
			<h2 class="history__section-headline secondary-headline">Work</h2>
			<div class="cards">
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Nov 2020</time>
							<time class="card__date card__date--end">Current</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">KPS3</h1>
							<p class="card__subheadline subheadline">Full Stack Developer</p>
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Nov 2019</time>
							<time class="card__date card__date--end">Nov 2020</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">KPS3</h1>
							<p class="card__subheadline subheadline">Designer / Full Stack Developer</p>
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Aug 2013</time>
							<time class="card__date card__date--end">Nov 2019</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Noble Studios</h1>
							<p class="card__subheadline subheadline">Creative Designer</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Jun 2013</time>
							<time class="card__date card__date--end">Aug 2013</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Noble Studios</h1>
							<p class="card__subheadline subheadline">Design Intern</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Jun 2010</time>
							<time class="card__date card__date--end">Current</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Freelance Marketing</h1>
							<p class="card__subheadline subheadline">All the Things</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
			</div>
			<h2 class="history__section-headline secondary-headline">Education</h2>
			<div class="cards">
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Aug 2010</time>
							<time class="card__date card__date--end">Jun 2013</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Truckee Meadows Community College</h1>
							<p class="card__subheadline subheadline">Graphic Communications</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Jun 2003</time>
							<time class="card__date card__date--end">Jun 2007</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Reno High School</h1>
							<p class="card__subheadline subheadline">Graphic Communications & Printmaking</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
			</div>
			<h2 class="history__section-headline secondary-headline">Notable Acheivements</h2>
			<div class="cards">
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">Aug 2014</time>
							<time class="card__date card__date--end">Current</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Skills USA Judge</h1>
							<p class="card__subheadline subheadline">Graphic Communications</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">May 2019</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">TMCC Portfolio Class Judge</h1>
							<p class="card__subheadline subheadline">Graphic Communications</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
				<article class="card">
					<div class="card__container">
						<div class="card__date-container">
							<time class="card__date card__date--start">May 2015</time>
						</div>
						<div class="card__content-container">
							<h1 class="card__title">Startup Weekend</h1>
							<p class="card__subheadline subheadline">Organizer & Participant/Group Lead</p>
							<!-- <p class="card__description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae pariatur alias blanditiis, minus beatae labore. Nemo illo quae mollitia sequi architecto ad dignissimos aliquid, ut dolor cum incidunt alias magnam.</p> -->
						</div>
					</div>
				</article>
			</div>

		</section>
		<section id="skills" class="skills">
			<h1 class="skills__headline headline">Skills & Experience</h1>
			<h2 class="skills__section-headline secondary-headline">Technical</h2>
			<div class="charts">
				<div class="charts__container">
					<LanguagesChart></LanguagesChart>
					<FrameworkChart></FrameworkChart>
				</div>
			</div>
			<h2 class="skills__section-headline secondary-headline">Design</h2>
			<div class="charts">
				<div class="charts__container">
					<DesignKnowledgeChart></DesignKnowledgeChart>
					<DesignToolsChart></DesignToolsChart>
				</div>
			</div>
			<h2 class="skills__section-headline secondary-headline">Design Examples</h2>
			<div class="charts">
				<div class="charts__container">
					<span>
						<img src="./../../public/img/yodlee.jpg" alt="">
					</span>
					<span>
						<img src="./../../public/img/central-coast.jpg" alt="">
					</span>
				</div>
			</div>
			<div class="charts">
				<div class="charts__container">
					<span>
						<img src="./../../public/img/gsr.jpg" alt="">
					</span>
					<span>
						<img src="./../../public/img/klaire.jpg" alt="">
					</span>
				</div>
			</div>
		</section>
	</div>
</main>

</template>

<script>
import LanguagesChart from '@/components/LanguagesChart'
import FrameworkChart from '@/components/FrameworkChart'
import DesignKnowledgeChart from '@/components/DesignKnowledgeChart'
import DesignToolsChart from '@/components/DesignToolsChart'
export default {
	components: {
		LanguagesChart,
		DesignKnowledgeChart,
		FrameworkChart,
		DesignToolsChart

	}
}

</script>

<style lang="sass">
	@import './public/sass/variables.sass'
	@import './public/sass/profile.sass'
	@import './public/sass/history.sass'
	@import './public/sass/skills.sass'
</style>